import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';
import classNames from 'classnames';
import get from 'lodash/get';
import { InputGroup, Input } from 'reactstrap';

import CopyKey from 'Components/Order/CopyKey';

export default function KeyRevealed({
  game,
  drm,
  bundleID,
  isCoupon,
  voucher,
}) {
  const [copied, setCopied] = useState(false);
  const [voucherError, setVoucherError] = useState(false);

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  const keys = game.key.split(';');
  const expireDate = game.serialExpiry ? new Date(game.serialExpiry) : '';
  const hasExpired = (expireDate !== '') && (new Date() > expireDate);

  const voucherCode = get(voucher, 'voucher.code');

  return (
    <React.Fragment>
      {isCoupon &&
        <React.Fragment>
          {voucherError &&
            <div className="voucher-error">
              <FormattedMessage id="reveal-key.voucher.error" defaultMessage="This coupon may be invalid, expired or not yet active." />
            </div>
          }
          {voucherCode === game.key &&
            <div className="voucher-applied">
              <FormattedMessage
                id="reveal-key.voucher.applied"
                defaultMessage="This coupon is active on your cart."
              />
            </div>
          }
        </React.Fragment>
      }
      {keys.map((key, i) =>
        <React.Fragment key={key}>
          {key.match(/{{(.*)}}/) &&
            <div className="text-left w-100 mt-2">{key.match(/{{(.*)}}/)[1]}</div>
          }
          <InputGroup className={classNames('key-revealed-container', { 'last-key': i + 1 === keys.length })}>
            <Input
              readOnly
              aria-label="reveal-key"
              type="text"
              value={copied ? 'Your key has been copied' : key.replace(/{{(.*)}}/, '')}
              className="key-input-field"
            />
            <div className="input-group-append">
              <CopyKey
                keyString={key.replace(/{{(.*)}}/, '')}
                drm={drm}
                bundleID={bundleID}
                pid={game._id}
                externalRedeemLink={game.external_redeem_link}
                appendRevealedKey={game.append_revealed_key}
                setVoucherError={setVoucherError}
                onCopy={onCopy}
              />
            </div>

          </InputGroup>

          {game.serialExpiry && hasExpired &&
            <div className="key-expire-text">
              <FormattedMessage
                id="reveal-key.expiredMessage"
                defaultMessage="This Key Has Expired"
              />
            </div>
          }
          {game.serialExpiry && !hasExpired &&
            <div className="key-expire-text">
              <FormattedMessage
                id="reveal-key.expiresMessage"
                defaultMessage="This Key Expires On"
              />
              &nbsp;
              <FormattedDate
                value={expireDate}
                year="numeric"
                month="long"
                day="2-digit"
                hour="2-digit"
                minute="2-digit"
                timeZone="UTC"
              />&nbsp;(UTC)
            </div>
          }
        </React.Fragment>,
      )}
    </React.Fragment>
  );
}

KeyRevealed.propTypes = {
  game: PropTypes.shape({}).isRequired,
  voucher: PropTypes.shape({}).isRequired,
  bundleID: PropTypes.string,
  drm: PropTypes.string,
  isCoupon: PropTypes.bool,
};

KeyRevealed.defaultProps = {
  bundleID: null,
  drm: '',
  isCoupon: false,
};
